<template>
	<b-modal v-model="isActive" has-modal-card :can-cancel="false" @close="closeModal()">
		<div class="modal-card modalCardContainer"
			style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
			<header class="modal-card-head" style="background-color: rgba(40, 40, 40, 1); color: white">
				Wichtiger Hinweis
			</header>
			<section class="modal-card-body" style="padding: 0.5em; color: black">
				<p>
					Ihr Session ist abgelaufen. Bitte melden Sie sich neu an.
				</p>
			</section>
			<footer class="modal-card-foot footerContainer" style="background-color: rgba(40, 40, 40, 1); color: white">
				<b-button type="is-primary" @click="loginNow">
					Jetzt neu anmelden
				</b-button>
			</footer>
		</div>
	</b-modal>
</template>

<script>

import { negativeFeedBack, positiveFeedBack } from "@/lib/Toast";
import Parse from "parse/dist/parse.min.js";

export default {
	name: "SessionInvalidModal",
	props: ["value"],
	data() {
		return {};
	},
	computed: {
		isActive: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	mounted() { },
	methods: {
		closeModal() {
			this.isActive = false;
		},
		async loginNow() {
			try {
				await Parse.User.logOut();
				await this.$router.push("/login");
				positiveFeedBack("Nutzer abgemeldet!");
				location.reload();
			} catch (e) {
				await this.$router.push("/login");
				location.reload();
			}
		}
	}
}

</script>

<style scoped></style>